<template>
  <v-navigation-drawer permanent class="navigation-rail" width="88px" aria-label="Main navigation">
    <v-list class="nav-logo">
      <img src="@/assets/logo.svg" alt="Fieldgather logo" />
    </v-list>

    <v-list nav dense class="navigation-rail-items" role="navigation" aria-label="Main menu">
      <button
        v-for="nav in navItems"
        :class="getNavItemClass(nav.id)"
        :key="nav.id"
        :aria-label="nav.title"
        :aria-current="NavigationStore.isSelected(nav.id) ? 'page' : undefined"
        @click="NavigationStore.toggleItem(nav.id)"
      >
        <span class="nav-item-inner">
          <v-icon>{{ nav.icon }} </v-icon>
          <span class="nav-item-label">{{ nav.title }}</span>
        </span>
      </button>
    </v-list>

    <v-list nav dense>
      <button
        :class="getNavItemClass('items.settings', 'user-profile')"
        :aria-label="'Settings for ' + getUserInitials()"
        :aria-current="NavigationStore.isSelected('items.settings') ? 'page' : undefined"
        @click="NavigationStore.toggleItem('items.settings')"
      >
        <span class="nav-item-inner">
          <v-list-item-avatar color="primary" width="52px" height="52px">
            <span class="white--text">{{ getUserInitials() }}</span>
          </v-list-item-avatar>
        </span>
      </button>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import _ from "lodash";

import AuthUtil from "@/util/AuthUtil.js";

import { NavigationStore } from "@/stores/NavigationStore.js";

const NAV_ITEMS = [
  {
    icon: "mdi-view-dashboard-outline",
    id: "items.dashboard",
    title: "Dashboard",
  },
  {
    icon: "mdi-clipboard-text-outline",
    id: "items.surveys",
    title: "Surveys",
  },
  {
    icon: "mdi-chart-box-outline",
    id: "items.reports",
    title: "Reports",
  },
  {
    icon: "mdi-plus",
    id: "items.create",
    title: "New Survey",
  },
  {
    icon: "mdi-account-group-outline",
    id: "items.company",
    title: "Company",
  },
];

export default {
  name: "NavigationRail",
  components: {},
  computed: {
    navItems: function () {
      return _.filter(NAV_ITEMS, (nav) => NavigationStore.shouldShow(nav.id));
    },
  },
  methods: {
    getNavItemClass(key, additionalClass) {
      return NavigationStore.isSelected(key)
        ? `selected-nav nav-item ${additionalClass}`
        : `nav-item ${additionalClass}`;
    },
    getUserInitials() {
      const user = AuthUtil.getUser();
      if (user) {
        return user.firstName[0] + user.lastName[0];
      }
      return "";
    },
  },
  data() {
    return {
      NavigationStore,
      navClose: false,
    };
  },
};
</script>

<style scoped>
.navigation-rail {
  z-index: 100;
}

.navigation-rail .nav-logo {
  padding: 0px;
  height: 70px;
  width: 88px;
  border-bottom: 1px solid #e0e0e0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.navigation-rail .nav-logo > img {
  height: 50px;
}

.navigation-rail .nav-logo > div:first-child {
  display: flex;
  justify-content: center;
  align-content: center;
  padding-top: 12px;
}

.navigation-rail .nav-logo > div:nth-child(2) {
  display: flex;
  justify-content: center;
  align-content: center;
  text-align: center;
  font-family: "Biryani";
  font-size: 13px;
}

.navigation-rail .nav-item {
  height: 88px;
  cursor: pointer;
  user-select: none;
  background: none;
  border: none;
  width: 100%;
  padding: 0;
  font-family: inherit;
  color: inherit;
  outline: none;
}

.nav-item-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}

.nav-item-inner .v-icon {
  margin-bottom: 4px;
}

.nav-item-label {
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
}

.navigation-rail .nav-item:focus-visible {
  outline: 3px solid var(--v-primary-base, #1565C0);
  outline-offset: -3px;
}

.navigation-rail .nav-item:hover {
  background: #cfcfcfbf;
}

.navigation-rail .nav-item.selected-nav:hover {
  background: #b5c8dd;
}

.navigation-rail .navigation-rail-items {
  padding: 0px;
}

.navigation-rail .navigation-rail-items .v-list-item {
  padding: 4px 20px;
  margin-bottom: 0px !important;
}

.navigation-rail .navigation-rail-items .v-list-item .v-list-item__icon {
  margin-right: 20px;
}

.navigation-rail .selected-nav {
  color: #1867c0 !important;
  background-color: #e3edf8;
}

.navigation-rail .selected-nav .v-icon {
  color: #1867c0 !important;
}

  .navigation-rail .user-profile {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 88px;
  height: 88px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  flex-direction: column;
}

.navigation-rail .user-profile:focus-visible {
  outline: 3px solid var(--v-primary-base, #1565C0);
  outline-offset: -3px;
}

.navigation-rail .user-profile > div:first-child {
  margin: 0px;
  padding-top: 0px;
  border-radius: 50%;
}

.navigation-rail .user-profile span {
  width: 100%;
  font-size: 1.2em;
}
</style>
